<div class="flex h-full">
  <aside
    aria-label="Dockable Sidebar"
    [ngClass]="{
      'dockable-sidebar--opened': sidebarService.visible(),
      'dockable-sidebar--collapsed': !sidebarService.visible(),
    }"
    class="sidebar"
    role="complementary"
  >
    <ul id="menu-item">
      <li
        *ngFor="
          let item of commonService.getActivatedMenuItems(
            sidebarService.menuItems()
          )
        "
        (click)="openDockableSideBar(item, $event)"
        (keydown.enter)="openDockableSideBar(item)"
        (keydown.space)="openDockableSideBar(item)"
        [ngClass]="{ 'active-menu': sidebarService.selectedMenu === item }"
        tabindex="0"
        class="menu-item"
      >
        <div class="menu-content">
          <i
            [ngClass]="item.icon"
            class="menu-icon"
            [pTooltip]="item.label"
            tooltipPosition="right"
          ></i>
          <span *ngIf="isDockableSidebarOpened" class="menu-label">
            {{ item.label }}
          </span>
        </div>
      </li>
    </ul>
  </aside>
</div>
